import {FormikProps, useFormik} from "formik";
import * as Yup from "yup";
import React, { FC, useState } from "react";
import {
    ActionTypeEnum, DailyTransactionTypeEnum,
    DeleteTransactionRequestModel,
} from "../../../models";
import { getLabelName, getUserId } from "../../../utils";
import { TextBox, ButtonBox } from "../..";
import {deleteTransactionInitialValue} from "../common/initialValues/initialValues";
import {useTransactionHandlers} from "../common/hooks/transactions/useTransactionHandlers";
import { useTransactionResponseObject} from "../common/hooks/transactions/useTransactionSelectors";


const createSubmitWithDomUpdate = (formik: FormikProps<any>, refs: Record<string, React.RefObject<HTMLInputElement>>) => {
    return (e: React.FormEvent) => {
        e.preventDefault();

        // Update all fields that have refs
        Object.entries(refs).forEach(async ([fieldName, ref]) => {
            if (ref.current) {
                const currentValue = ref.current.value;
                await formik.setFieldValue(fieldName, currentValue, false);
            }
        });

        // Submit the form immediately after updating values
        formik.handleSubmit();
    };
};

export const DeleteTransactionComponent: FC<{
    transactionType: DailyTransactionTypeEnum;
    formId: number;
}> = ({ transactionType,formId}) => {
    //#region state
    const { handleAction } = useTransactionHandlers(transactionType,formId);
    const request = useTransactionResponseObject()
    const [validationSchema] = useState(
        Yup.object({
            DeleteReason: Yup.string()
                .required(getLabelName("Delete Reason missing"))
                // .test("debug", "res_x_1_Debug Log", (value) => {
                //     console.log("🔍 res_x_1_Yup validation triggered:", value);
                //     return true; // don’t block validation
                // }),
        })
    );
    const [object, setObject] = useState<DeleteTransactionRequestModel>(
        request != null
            ? {
                TrnsactionId: request.id,
                TransactionTypeId: request.transactionType,
                User_ID: getUserId(),
                VoucherSetting_ID: 0,
                DeleteReason: "",
                ValueOfPoint: 0,
                InstallmentPlanId: 0,
                IsContainsItemSerial: false,
                ItemSerialList: [],
            }
            : deleteTransactionInitialValue
    );
    //#endregion
    //#region formik
    const formik = useFormik({
        initialValues: object,
        validationSchema: validationSchema,
        validateOnBlur: false,
        validateOnChange: true,
        // validate,
        // enableReinitialize: true,
        onReset: async () => {
            await handleAction({
                id: 0,
                action: ActionTypeEnum.Clear,
            });
        },
        onSubmit: async (values, { validateForm }) => {
             // const errors = await validateForm();
             // console.log('res_x_1_errors',errors);
            setObject({ ...object, DeleteReason: values.DeleteReason });
            await handleAction({
                id: values.TrnsactionId,
                request: { ...object, DeleteReason: values.DeleteReason },
                action: ActionTypeEnum.Delete,
            });
        },
    });
    //#endregion
    //#region html
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row row-cols-1 row-cols-xxl-12 row-cols-xl-12 row-cols-lg-12 row-cols-md-12 row-cols-sm-12 g-md-12 g-sm-12">
                <TextBox
                    labelName={getLabelName("Delete Reason")}
                    inputName="DeleteReason"
                    inputValue={formik.values.DeleteReason ?? ""} // always controlled
                    errorText={formik.touched.DeleteReason ? formik.errors.DeleteReason : undefined}
                    onChange={(v: any) =>
                        formik.setFieldValue("DeleteReason", v?.target?.value ?? v ?? "")
                    }
                    onBlur={formik.handleBlur} // do NOT change value here
                    type="textarea"
                />
            </div>
            <div className="row mt-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
                    <ButtonBox type="submit">{getLabelName("ok")}</ButtonBox>
                    <ButtonBox
                        variant="danger"
                        iconType="receipt"
                        onClick={async () => {
                            setObject(deleteTransactionInitialValue);
                            await handleAction({
                                id: 0,
                                request: {},
                                action: ActionTypeEnum.DeleteReset,
                            });
                        }}
                    >
                        {getLabelName("Cancel")}
                    </ButtonBox>
                </div>
            </div>
        </form>
    );
    //#endregion
};
